(function () {
  if (window.__vhfx) return;
  window.__vhfx = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  // Guarda los productos vistos para la sección "Vistos recientemente"
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (m) {
    try {
      var l = JSON.parse(localStorage.getItem('vh_recent') || '[]');
      l = l.filter(function (h) { return h !== m[1]; });
      l.unshift(m[1]);
      localStorage.setItem('vh_recent', JSON.stringify(l.slice(0, 10)));
    } catch (e) {}
  }

  function reveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    root.classList.add('vh-fx');
    var sel = '.vh-h,.vh-sub,.vh-tile,.vh-mcard,.vh-bn__item,.vh-rail__item,.vq__card,.vc__in,.vtab__bar,.vtab__panel .vh-card,.vs__item,.vm__intro,.vr__item';
    var els = Array.prototype.slice.call(document.querySelectorAll(sel)).filter(function (e) { return !e.closest('.vh-hero') && !e.closest('.vt'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) {
      var sibs = e.parentNode ? Array.prototype.slice.call(e.parentNode.children) : [e];
      e.style.transitionDelay = Math.min(sibs.indexOf(e), 5) * 80 + 'ms';
      e.classList.add('vh-rv');
      io.observe(e);
    });
  }

  function parallax() {
    var hero = document.querySelector('.vh-hero');
    if (!hero || reduce) return;
    var imgs = hero.querySelectorAll('.vh-slide__img');
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, hero.offsetHeight);
        imgs.forEach(function (i) { i.style.setProperty('--py', (y * 0.18).toFixed(1) + 'px'); });
        ticking = false;
      });
    }, { passive: true });
  }

  function zoom() {
    if (!(window.matchMedia && window.matchMedia('(hover: hover)').matches)) return;
    document.querySelectorAll('.vp__slide').forEach(function (s) {
      var img = s.querySelector('img');
      if (!img) return;
      s.addEventListener('mouseenter', function () { s.classList.add('is-zoom'); });
      s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); img.style.transformOrigin = '50% 50%'; });
      s.addEventListener('mousemove', function (e) {
        var r = s.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
    });
  }

  function boot() { reveal(); parallax(); zoom(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();